// 开发期日志的唯一出口。
//
// widget 跑在客户网站上，裸 console.log 既污染客户的 console，也会把内部状态
// （appConfig、visitor uuid、session_id…）泄到宿主页。所以两道闸：
//   1) 生产构建 terser 用 drop_console: ['log','debug','info'] 整体剔除
//      （warn / error 保留 —— SW 注册降级之类的诊断要留着）；
//   2) 源码侧统一走这里，运行时再判一次内部开关。
// 第二道闸的意义：即便某条构建路径没 strip 干净，客户 console 依然是干净的。
//
// ---------- 为什么不再是 window.laneChatDebug ----------
// 那是个写进对外文档的布尔量，等于邀请客户在自己站点上打开我们的内部日志。
// 2026-08 起改成不公开的令牌开关：知道 key 名还不够，值必须等于 DIAG_TOKEN。
// 这是混淆不是鉴权 —— 令牌本身就在 bundle 里，肯下功夫的人能扒出来。它挡的是
// 顺手试试的客户和照着旧文档抄的人，不是攻击者。真正的防线是 debugLog 永远
// 不打凭证；这一条比开关重要得多，以后加日志时守住。
// 完全砍掉运行时能力不行：drop_console 已经把 log/debug/info 剥光，线上再出
// “只有某个客户能复现”的问题就彻底瞎了（踩过）。
//
// ---------- 我们自己怎么开 ----------
//   localStorage.setItem('__lcx', 'lcdiag-4f9c2e7a')   // 活到手动清除，刷新后仍在
//   window.__lcx = 'lcdiag-4f9c2e7a'                   // 只对当前页有效
// 想把日志收走而不是打进 console，再给 window.__lcxSink = (args) => {...}。
// 关掉：localStorage.removeItem('__lcx')。
//
// 注意不要写成 window.console.log(...) —— terser 的 drop_console 只认裸的
// console 全局引用，window.console.* 会原样留在 bundle 里（这正是第 30 项
// 里那批 'know' / 'chat' 日志躲过 strip 的原因）。
const DIAG_KEY = '__lcx';
const DIAG_TOKEN = 'lcdiag-4f9c2e7a';

/**
 * 诊断模式是否打开。window 优先于 localStorage（临时覆盖用）。
 * localStorage 在沙箱 iframe / 禁三方存储的浏览器里会直接抛，必须兜住。
 */
export function isDiagEnabled() {
    if (typeof window === 'undefined') return false;
    if (window[DIAG_KEY] === DIAG_TOKEN) return true;
    try {
        return window.localStorage.getItem(DIAG_KEY) === DIAG_TOKEN;
    } catch (e) {
        return false;
    }
}

export const debugLog = (...args) => {
    if (!isDiagEnabled()) return;
    // 自定义 sink：开关已经验过令牌，这里只认函数。
    const hook = window.__lcxSink;
    if (typeof hook === 'function') { hook(args); return; }
    // 不写 console.log(...)：那一行会被 terser 的 drop_console 一起剔除，
    // 人工开关就成了死开关。走本地变量取方法，静态匹配不到，行为完全一致。
    const c = window.console;
    const sink = c && c.log;
    if (sink) sink.apply(c, args);
};

export default debugLog;
